import React from 'react';
import resume from "../assets/corey-resume.pdf";
import {Button} from "@material-ui/core";

function DownloadButton() {
  return (
    <Button
        download={true}
        href={resume}
        className="download-button"
    >
      Download Resume
    </Button>
  );
}

export default DownloadButton;
